import { Component, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { GridModule } from '@syncfusion/ej2-angular-grids';
import { WordReplacementService } from './services/word-replacement.service';
import { GeneralService } from './services/general.service';
import { ANGULAR_MODULES } from './Shared/shared-imports';
import { firstValueFrom, Subscription } from 'rxjs';
import { UserService } from './services/User.service';
import { IUserPermissionsModel } from './Shared/model/AdminUserModel';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [ANGULAR_MODULES, RouterOutlet, GridModule],
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  constructor(private wordReplacementService: WordReplacementService,
    private generalService: GeneralService,
    private userService: UserService
  ) { }

  async ngOnInit(): Promise<void> {
    this.subscriptions.push(this.generalService.getTermsUsedInMarket().subscribe(res => {
      this.wordReplacementService.setTermMap({
        booth: res.BoothTerm,
        vendor: res.VendorTerm,
        market: res.MarketTerm
      });
    }));
    if(!this.userService.getLoggedInUserName()) {
      const loggedInUserName = localStorage.getItem('ASCUserName');
      const loggedInUserId = localStorage.getItem('ASCUserId');
      if (loggedInUserName) {
        this.userService.setLoggedInUserName(loggedInUserName);
        this.userService.setLoggedInUserId(parseInt(loggedInUserId, 10));
        if (!this.generalService.UserPermissions) {
          try {
            const userPermission: IUserPermissionsModel = await firstValueFrom(this.generalService.GetUserPermission());
            this.generalService.UserPermissions = userPermission;
            this.generalService.userGroupPermissions.emit(userPermission);
          } catch (error) {
            console.error('Error fetching user permissions', error);
          }
        }
      }
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      if (subscription) {
        subscription.unsubscribe();
      }
    });
  }
}
